import moment from 'moment'
import { IMG_URL } from './response'


export const removeHttps = (url) => {
    if (!url) return '';
    return url.replace(/^https:\/\//, '');
};
export const ensureHttpsUrl = (url) => {
    if (!url) return '';
    return url.startsWith('https://') ? url : `https://${url}`;
};
const roundFixed = (val) => {
   return Number(val)?.toFixed(1)
};

const urlToFile = async (url, filename) => {
    try {
        const response = await fetch(url);
        const blob = await response.blob();
        const fileType = blob.type || 'application/octet-stream'; // Default MIME type if unknown
        return new File([blob], filename, { type: fileType });
    } catch (error) {
        console.error('Error converting URL to file:', error);
        return null;
    }
};

const dateFormat = (date) => {
    var formatDate = new Date(date)
    var dd = String(formatDate.getDate()).padStart(2, '0')
    var mm = String(formatDate.getMonth() + 1).padStart(2, '0') //January is 0!
    var yyyy = formatDate.getFullYear()

    return (formatDate = yyyy + '-' + mm + '-' + dd)
}

const postedDurations = (date) => {
    var duration = moment(date).startOf('data').fromNow(date)

    return `Posted - ${duration} ago`
}
const postedDuration = (date) => {
    const now = new Date()
    const createdDate = new Date(date)
    console.log(`${now} and ${createdDate}`)
    const diffTime = Math.abs(now - createdDate)
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24))
    const diffHours = Math.floor(
        (diffTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    )
    const diffMinutes = Math.floor((diffTime % (1000 * 60 * 60)) / (1000 * 60))

    if (diffDays === 0) {
        return `Posted - today`
    } else if (diffDays === 1) {
        return `Posted - ${diffDays} day ago`
    } else if (diffDays > 0) {
        return `Posted - ${diffDays} days ago`
    } else if (diffHours > 0) {
        return `Posted - ${diffHours} hours ago`
    } else if (diffMinutes > 0) {
        return `Posted - ${diffMinutes} minutes ago`
    } else {
        return `Posted - today`
    }
}
function toggleFullScreen() {
    if (
        !document.fullscreenElement && // alternative standard method
        !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
    ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
            document.documentElement.requestFullscreen()
        } else if (document.documentElement.mozRequestFullScreen) {
            document.documentElement.mozRequestFullScreen()
        } else if (document.documentElement.webkitRequestFullscreen) {
            document.documentElement.webkitRequestFullscreen(
                Element.ALLOW_KEYBOARD_INPUT
            )
        }
    } else {
        if (document.cancelFullScreen) {
            document.cancelFullScreen()
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen()
        } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen()
        }
    }
}

const diffTwoTime = (start_date, end_date) => {
    console.log(start_date, 'start_date')
    console.log(end_date, 'end_date')
    const endDate = new Date(end_date)
    const startDate = new Date(start_date)

    var a = moment(endDate)
    var b = moment(startDate)
    var years = a.diff(b, 'year')
    b.add(years, 'years')

    var months = a.diff(b, 'months')
    b.add(months, 'months')

    var days = a.diff(b, 'days')

    if (years > 0) {
        return years + ' years ' + months + ' months ' + days + ' days'
    }
    if (months > 0) {
        return months + ' months ' + days + ' days'
    }
    if (days > 0) {
        return days + ' days'
    }
    return 'null'
    // 8 years 5 months 2 days
}

const averageNumber = (...args) =>
    (args.reduce((a, b) => a + b) / args.length).toFixed(2)

const imagePath = (image) => {
    console.log(`${IMG_URL}/${image}`)
    return `${IMG_URL}/${image}`
}

export {
    roundFixed,
    urlToFile,
    dateFormat,
    postedDuration,
    toggleFullScreen,
    diffTwoTime,
    imagePath,
    averageNumber,
}
